export const droplinkRoutes = [
  {
    path: '/droplink/campaign/:id',
    name: 'campaign_landing',
    component: () => import('@/views/droplink/CampaignLandingView.vue'),
  },
  {
    path: '/droplink/campaign/:id/quest',
    name: 'quest_main',
    component: () => import('@/views/droplink/CampaignQuestMain.vue'),
    children: [
      {
        path: 'attend',
        name: 'quest_attend',
        component: () => import('@/views/droplink/CampaignQuestAttend.vue'),
      },
    ],
  },
  {
    path: '/droplink/campaign/:id/quest/complete',
    name: 'quest_complete',
    component: () => import('@/views/droplink/CampaignQuestComplete.vue'),
  },
  {
    path: '/droplink/campaign/:id/reward',
    name: 'campaign_reward',
    component: () => import('@/views/droplink/CampaignReward.vue'),
  },
  {
    path: '/droplink/campaign/:id/signup',
    name: 'campaign_signup',
    component: () => import('@/views/auth/droplink/CampaignSignupMain.vue'),
    children: [
      {
        path: 'login_select',
        name: 'campaign_signup_select',
        component: () =>
          import('@/views/auth/droplink/CampaignSignupSelector.vue'),
      },
      {
        path: 'set_password',
        name: 'campaign_signup_with_email_set_password',
        component: () =>
          import('@/views/auth/droplink/CampaignSignupSetPassword.vue'),
      },
      {
        path: 'set_pin',
        name: 'campaign_signup_with_email_set_pin',
        component: () =>
          import('@/views/auth/droplink/CampaignSignupSetPin.vue'),
      },
      {
        path: 'create_account',
        name: 'campaign_signup_create_account',
        component: () =>
          import('@/views/auth/droplink/CampaignSignupCreateAccount.vue'),
      },
    ],
  },
  {
    path: '/droplink/campaign/:id/check_email',
    name: 'campaign_check_email',
    component: () => import('@/views/droplink/CampaignCheckEmail.vue'),
  },
  {
    path: '/droplink/campaign/:id/check_set_pin',
    name: 'campaign_check_set_pin',
    component: () => import('@/views/droplink/CampaignCheckSetPin.vue'),
  },
  {
    path: '/droplink/campaign/:id/already_rewarded',
    name: 'campaign_already_rewarded',
    component: () => import('@/views/droplink/CampaignAlreadyRewarded.vue'),
  },
  {
    path: '/droplink/campaign/:id/middleware',
    name: 'campaign_middleware',
    component: () => import('@/views/droplink/CampaignMiddleware.vue'),
  },
]
